import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rate-limit-exceeded',
  templateUrl: './rate-limit-exceeded.component.html',
  styleUrls: ['./rate-limit-exceeded.component.css']
})
export class RateLimitExceededComponent implements OnInit {
  countdown: number = 60;
  private interval: any;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.startCountdown();
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  private startCountdown(): void {
    this.interval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.interval);
        this.router.navigate(['/']);
      }
    }, 1000);
  }

  goHome(): void {
    this.router.navigate(['/']);
  }
}
